Vue.component("image-boxes-carousel", {

    template: `<div>
        <div class="loader-wrapper" ref="loader">
            <div class="loader">
                <div class="dot"></div><div class="dot"></div><div class="dot"></div><div class="dot"></div>
                <div class="dot"></div><div class="dot"></div><div class="dot"></div><div class="dot"></div>
            </div>
        </div>
        <div v-if="imageboxes.length > 0" class="owl-carousel owl-carousel-imagebox owl-theme" ref="carousel">
            <div class="item" v-for="(imagebox, index) in imageboxes">
                <a :href="imagebox.url" class="banner" :target="getTarget(imagebox)">
                    <span class="figure">
                        <img v-if="imagebox.imageUrl" class="owl-lazy" :data-src="imagebox.imageUrl" :alt="imagebox.name">
                        <span class="figcaption" v-if="imagebox.name || imagebox.buttonText">
                            <span class="block-table">
                                <span class="block-table-cell">
                                    <span v-if="imagebox.name" class="banner__title">\${ imagebox.name }</span>
                                    <span v-if="imagebox.buttonText" class="btn btn-primary btn-shop-link">\${ imagebox.buttonText }</span>
                                </span>
                            </span>
                        </span>
                    </span>
                </a>
            </div>
        </div>
    </div>`,

    props: {
        imageboxesData: {
            type: Array
        },
        responsiveOne: {
            type: Number,
            default: 1
        },
        responsiveTwo: {
            type: Number,
            default: 2
        },
        responsiveThree: {
            type: Number,
            default: 3
        }
    },

    computed: {
        imageboxes()
        {
            return this.imageboxesData;
        }
    },

    mounted()
    {
        this.$nextTick(() =>
        {
            if (this.imageboxes && this.imageboxes.length > 0)
            {
                this.initializeCarousel();
            }
        });
    },

    methods: {
        getTarget(imagebox)
        {
            return imagebox && imagebox.openInNewTab ? "_blank" : "_self";
        },

        initializeCarousel()
        {
            const noMargin = $(this.$refs.carousel).closest(".widget-image-boxes-carousel").hasClass("full-width");

            $(this.$refs.carousel).owlCarousel({
                dots: false,
                loop: this.imageboxes.length >= this.responsiveThree,
                lazyLoad: true,
                margin: (noMargin ? 0 : 15),
                nav: true,
                navText: [
                    `<i id="owl-nav-text-left-${this._uid}" class='fa fa-chevron-left' aria-hidden='true'></i>`,
                    `<i id="owl-nav-text-right-${this._uid}" class='fa fa-chevron-right' aria-hidden='true'></i>`
                ],
                responsiveClass: true,
                responsive: {
                    0: {
                        items: this.imageboxes.length >= this.responsiveOne ? this.responsiveOne : this.imageboxes.length
                    },
                    600: {
                        items: this.imageboxes.length >= this.responsiveTwo ? this.responsiveTwo : this.imageboxes.length
                    },
                    1000: {
                        items: this.imageboxes.length >= this.responsiveThree ? this.responsiveThree : this.imageboxes.length
                    }
                },
                onInitialized: event =>
                {
                    $(this.$refs.loader).addClass("loaded");

                    document.querySelector(`#owl-nav-text-left-${this._uid}`).parentElement.onclick = event => event.preventDefault();
                    document.querySelector(`#owl-nav-text-right-${this._uid}`).parentElement.onclick = event => event.preventDefault();
                }
            });
        }
    }
});
